/*
document.addEventListener("DOMContentLoaded", function () {
  var targetElement = document.querySelector(
    "#shopify-section-template--15065958481987__1652213013539a7c23"
  );
  // "#shopify-section-template--15060745551939__1652213013539a7c23"
  window.addEventListener("click", (event) => {
    if (
      event.target.id ===
        "shopify-block-89359631-26a5-4f16-8f7c-67c583012071" ||
      event.target.parentElement.id ===
        "shopify-block-89359631-26a5-4f16-8f7c-67c583012071"
    ) {
      // Perform your action when the element with id "thisisclicker" or its parent is clicked
      targetElement.scrollIntoView({ behavior: "smooth" });
    }
  });
}); */

$(document).ready(function () {
  // When the button with the id of 'scrollButton' is clicked
  $(".desktop-stamped-windrider").click(function () {
    // Scroll to the element with the id of 'content'
    $("html, body").animate(
      {
        scrollTop: $("#stamped-main-widget").offset().top,
      },
      1000
    ); // The number 1000 denotes the animation duration in milliseconds
  });
});
